module.exports = __webpack_public_path__ + "img/busca-tematica-especies-exotica.907376e9.jpg";